"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * IframeCell - Composant iframe responsive
 * 
 * @param {Object} props
 * @param {string} props.url - URL à afficher dans l'iframe
 * @param {string} [props.title='Contenu intégré'] - Titre de l'iframe pour l'accessibilité
 * @param {Object} [props.styles_properties] - Propriétés de style
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {Object} [props.style] - Styles inline additionnels
 * @param {boolean} [props.allowFullScreen=true] - Autoriser le plein écran
 * @param {string} [props.sandbox] - Attribut sandbox pour la sécurité
 * @param {string} [props.allow] - Permissions (ex: 'autoplay; fullscreen')
 * @param {Function} [props.onLoad] - Callback quand l'iframe est chargée
 * @param {Function} [props.onError] - Callback en cas d'erreur
 */const IframeCell = ({
  url,
  title = 'Contenu intégré',
  styles_properties = {},
  className = '',
  style = {},
  allowFullScreen = true,
  sandbox,
  allow,
  onLoad,
  onError,
  ...rest
}) => {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [hasError, setHasError] = (0, _react.useState)(false);

  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color || '#f5f5f5',
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    ...style
  };
  const handleLoad = e => {
    setIsLoading(false);
    if (onLoad) onLoad(e);
  };
  const handleError = e => {
    setIsLoading(false);
    setHasError(true);
    if (onError) onError(e);
  };
  const containerClasses = ['iframe-cell', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: containerClasses,
    style: containerStyle,
    ...rest,
    children: [isLoading && !hasError && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "iframe-cell__loading",
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f0f0'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "Chargement..."
      })
    }), hasError && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "iframe-cell__error",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: '#f8d7da',
        color: '#721c24'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "Impossible de charger le contenu"
      })
    }), !hasError && /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      className: "iframe-cell__iframe",
      src: url,
      title: title,
      allowFullScreen: allowFullScreen,
      sandbox: sandbox,
      allow: allow,
      onLoad: handleLoad,
      onError: handleError,
      style: {
        opacity: isLoading ? 0 : 1,
        transition: 'opacity 0.3s ease-in-out'
      }
    })]
  });
};
var _default = exports.default = IframeCell;